// Vendor
import * as React from 'react';

// Internal
import { Hero, HeroProps } from '@src/components/Hero';

export interface SectionProps {
  hero: HeroProps;
  id: string;
}

const Section: React.FC<SectionProps> = (props) => {
  const { children, hero, id } = props;

  return (
    <section className="tup-section" id={id}>
      <header>
        <Hero {...hero} />
      </header>
      <main>{children}</main>
    </section>
  );
};

export { Section };
